import React, { useState } from 'react';
const faqs = [{
  q: 'What is the Magic Party Kit and what exactly does it include?',
  a: "The Magic Party Kit is a digital collection of +10,000 printable designs for kids' party decorations. It includes invitations, cake toppers, candy boxes, banners, stickers, backgrounds, labels, candy bar decorations, and much more. Everything comes in PDF, PNG, SVG, and DXF formats, editable with Canva for free. Plus, you receive 10 exclusive bonuses at the time of purchase."
}, {
  q: 'How do I receive the kit? Does the access expire?',
  a: "You'll receive an email with the download link immediately after completing your payment. The access never expires — once you download it, it's yours forever. You can use it for as many parties as you want."
}, {
  q: 'Do I need design experience or special software?',
  a: 'No experience needed at all. The designs are editable with free Canva, which you can use from your phone or computer without installing anything. The kit includes step-by-step tutorials to guide you through the entire process.'
}, {
  q: 'Do I need to pay for Canva to use the designs?',
  a: "No. Canva has a free version that is more than enough to customize all the designs in the kit. You don't need the premium version. Just create a free account at canva.com and you're all set."
}, {
  q: 'Can I use the kit to sell decorations or start a business?',
  a: 'Yes! The kit includes Bonus 10: Guide to Starting a Party Business, where we explain step by step how to use these designs to offer decoration services in your city or online. Many moms are already earning extra income with this same kit.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-light-pink" data-id="element-42">
      <div className="max-w-3xl mx-auto" data-id="element-43">
        <h2 className="text-3xl md:text-5xl font-bold text-center text-magenta mb-12 font-baloo" data-id="element-44">
          ❓ FREQUENTLY ASKED QUESTIONS
        </h2>

        <div className="space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-2xl shadow-sm border-2 border-pink-100 overflow-hidden" data-id="element-46">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-pink-50 transition-colors" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-47">
                <span className="font-bold text-lg text-gray-800 font-baloo pr-4" data-id="element-48">
                  {faq.q}
                </span>
                <span className={`text-magenta font-bold text-2xl transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`} data-id="element-49">
                  +
                </span>
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-50">
                <p className="text-gray-600 leading-relaxed pt-2 border-t border-pink-50" data-id="element-51">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}